import { Box } from '@mui/material';
import * as Sentry from '@sentry/react';
import { roi } from '../constants/strings/roi';
import { ROILayout } from '../modules/roi/components/roi-layout';

export const ROIPage = (): JSX.Element => (
  <Sentry.ErrorBoundary fallback={<Box>{roi.error}</Box>}>
    <ROILayout />
  </Sentry.ErrorBoundary>
);
